import React from 'react';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
//import Container from 'components/Container';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
//import { FormControlLabel} from '@mui/material';

import Button from '@mui/material/Button';
import { Checkbox } from '@mui/material';





const Description = ({ thirdState, handleCurrentStep }) => {
  
  const mock = [
    {
      name: '1. Birth Certificate ',
      email: '',
      title: '',
      status: '',
      href:'', 
    },
    {
      name: '2. Aadhar/Passport',
      email: '',
      title: '',
      status: '',
      href:'',
    },
    {
      name: '3. Father Aadhar',
      email: '',
      title: '',
      status: '',
      href:'',
    },
    {
      name: '4. Mother Aadhar',
      email: '',
      title: '',
      status: '',
      href:'',
    },
  ];

  mock[0].href=thirdState.photoAadhar;
  mock[1].href=thirdState.photoBirth;
  mock[2].href=thirdState.photoFatherAadhar;
  mock[3].href=thirdState.photoMotherAadhar;
  

  return (
    <Box>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700}} aria-label="">
        <TableHead sx={{ bgcolor:'#377dff'}} padding>
        <TableRow>
          <TableCell>
            {/* <Typography
             
              fontWeight={700}
              // sx={{ textTransform: 'uppercase' }}
            >
            </Typography> */}
          </TableCell>
          <TableCell>
            <Typography
              variant={'caption'}
              color={'white'}

              fontWeight={700}
              sx={{ textTransform: 'uppercase' }}
              alignContent={'center'}
            >
              Documents
            </Typography>
          </TableCell>
          <TableCell>
            <Typography
              variant={'caption'}
              fontWeight={700}
              sx={{ textTransform: 'uppercase' }}
            >
              
            </Typography>
          </TableCell>
          <TableCell>
            <Typography
              variant={'caption'}
              fontWeight={700}
              sx={{ textTransform: 'uppercase' }}
            >
              
            </Typography>
          </TableCell>
          <TableCell>
            <Typography
              variant={'caption'}
              fontWeight={700}
              sx={{ textTransform: 'uppercase' }}
            >
              
            </Typography>
          </TableCell>
          <TableCell />
        </TableRow>
      </TableHead>
          <TableBody>
            {mock.map((item, i) => (
              <TableRow
                key={i}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                }}
              >
                <TableCell component="th" scope="row">
                  <Typography variant={'subtitle2'} fontWeight={700}>
                    {item.name}
                   
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.email}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.title}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    variant={'caption'}
                    fontWeight={700}
                  >
                    {item.status}
                  </Typography>
                  <Box
                    component={Button}
                    href= {item.href}
                    color="primary"
                    size="small"
                    marginTop={2}
                    variant={'outlined'}
                    endIcon={
                      <Box
                        component={'svg'}
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        width={24}
                        height={24}
                      >
                        <path
                          fillRule="evenodd"
                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                          clipRule="evenodd"
                        />
                      </Box>
                    }
                    sx={{ float: 'right' }}
                  >
                    Click View
                  </Box>
                </TableCell>
                <TableCell>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.role}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    color={'primary'}
                    variant={'subtitle2'}
                    fontWeight={700}
                    sx={{ cursor: 'pointer' }}
                  >
                    
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      
      </TableContainer>
      <br />
      <Box>
        <Typography  color="primary">
          <strong> 
         
            
            
            DECLARATION BY PARENT/GUARDIAN
          </strong>
          <br />
        </Typography>
        
        <Typography>     <Checkbox />
          I have <Link href={'not-found'} underline="none">
            read the rules and regulations
          </Link> of NATIONAL PUBLIC SCHOOL - YESHWANTHPUR and
          I fully agree to abide by them so long as my child is a student at this school if selected.
        </Typography>
        <Typography>
          I hereby declare that the information furnished above is true and correct to the best of my knowledge and I undertake to inform you of any changes therein, immediately.

        </Typography>
        <Typography>
          <strong>
            Application once submitted connot be edited. Kindly note your application no : YPR/NUR/2022/00981
          </strong>
        </Typography>
        
        <Box
          component={Button}
          variant="contained"
          size="large"
          height={54}
          marginTop={{ xs: 8, sm: 9 }}
          marginLeft={{ sm: 35 }}
          
         // href='/startup'
        >
          <span onClick={() => handleCurrentStep(1)}> Edit Application</span>  
       
        </Box> 
      
        <Box
          component={Button}
          variant="contained"
          bgcolor="primary"
          size="large"
          height={54}
          //href={""}
          marginTop={{ xs: 8, sm: 9 }}
          marginLeft={{ sm: 4 }}
        >
          <span onClick={() => handleCurrentStep(5)}> Submit</span>  
        </Box>

      </Box>
    </Box>    
  );
};







export default Description;